(function($) {

	$('.footer__contact__bar, .foot-prompt').hover(function(){
		$('.footer__contact__bar, .foot-prompt').addClass('hover');
	}, function(){
		$('.footer__contact__bar, .foot-prompt').removeClass('hover');
	})

	$('.footer__contact__bar').on('click',function(){
		var bar = $(this);
		bar.parent().toggleClass('scrolled-to');
        var offset  = $('.header__top').outerHeight() + 10;
        $('html, body').animate({
            scrollTop: bar.offset().top - offset
        }, 400,function(){
        	if (bar.parent().hasClass('scrolled-to')) {
        		bar.text('How can I help?');
        	} else {
        		bar.text('Begin the process...');
        	}
        });
	});

})( jQuery );  